import { defineMessages } from 'react-intl';

export default defineMessages({
  today: {
    id: 'app.components.Timeline.today',
    defaultMessage: 'Hoje',
  },
  date: {
    id: 'app.components.Timeline.date',
    defaultMessage: '{day}, {date}',
  },
});
